// Module
var code = "<div class=\"form-custom-control\"> <!-- ko template: { name: GetDesignTemplateName.bind($rawData), afterRender: $rawData.AfterRender.bind($rawData) } --><!-- /ko --> </div>";
// Exports
export default code;